import Log from './Log';
var JsApi = /** @class */ (function () {
    function JsApi() {
        this.canUseNativeAndroid = window.mqq && window.mqq.android && window._mqqWebViewJSInterface && window._mqqWebViewJSInterface.invoke;
        this.currentSeqId = 0;
        this.reqCallbacks = new Map();
    }
    JsApi.prototype.JSApiCallback = function (response) {
        var reqCallback = this.reqCallbacks.get(response.callbackId);
        if (reqCallback) {
            var callback = reqCallback.callback, command = reqCallback.command, startTime = reqCallback.startTime;
            if (callback) {
                Log.debug("callback invokeNative-" + response.callbackId + "-" + command + "-" + (Date.now() - startTime) + "ms", this.canUseNativeAndroid, "response=" + JSON.stringify(response));
                callback(response);
            }
        }
        else {
            Log.warn("callback invokeNative-" + response.callbackId + " reqCallback not found");
        }
    };
    JsApi.prototype.createReqSeq = function () {
        return this.currentSeqId++;
    };
    /**
     * 通过jsAPi和客户端通信
     * @param moduleName
     * @param method
     * @param requestData
     * @param callback
     */
    JsApi.prototype.invokeNative = function (moduleName, method, requestData, callback) {
        var callbackId = this.createReqSeq();
        var command = requestData.command;
        this.reqCallbacks.set(callbackId, { callback: callback, command: command, startTime: Date.now() });
        Log.debug("start call invokeNative-" + callbackId + "-" + command, moduleName, method, command, this.canUseNativeAndroid, "request=" + JSON.stringify(requestData));
        requestData.callbackId = callbackId; // 加上callbackId
        if (this.canUseNativeAndroid) {
            this.invokeNativeAndroid(moduleName, method, requestData);
        }
        else {
            window.mqq && window.mqq.invoke(moduleName, method, requestData);
        }
    };
    JsApi.prototype.invokeNativeAndroid = function (moduleName, method, requestData) {
        var url = "jsbridge://" + encodeURIComponent(moduleName) + "/" + encodeURIComponent(method);
        if (requestData) {
            url += "?p=" + encodeURIComponent(JSON.stringify(requestData));
        }
        // Log.debug("calling _mqqWebViewJSInterface with " + url)
        window._mqqWebViewJSInterface.invoke(url);
    };
    /**
     * 获取离线代码默认版本号
     * @param type 代码类型
     * @param callback 回调
     */
    JsApi.prototype.defaultOfflineCodeVersion = function (type, callback) {
        Log.debug("defaultOfflineCodeVersion-" + type);
        window.mqq && window.mqq.invoke('docx', 'defaultOfflineCodeVersion', {
            type: type,
        }, function (res) {
            Log.debug("defaultOfflineCodeVersion-" + type);
            callback && callback(res);
        });
    };
    return JsApi;
}());
var JSApi = window.jsApi;
if (!window.jsApi) {
    JSApi = new JsApi();
    window.jsApi = JSApi;
    if (!window.JSApiCallback) {
        window.JSApiCallback = JSApi.JSApiCallback.bind(JSApi);
    }
}
export { JSApi };
//# sourceMappingURL=JSApi.js.map